import axios from 'axios';
import { config } from '../env-helpers';

export const baseInstance = axios.create({
  baseURL: config.API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
